import { useUIStore } from '../store';
import { VisualContent } from '../interfaces/domain/menu';
import { useMemo } from 'react';

export const useContentCard = (content: VisualContent) => {
  // 1. SELECTOR ATÓMICO (Solo escucha la versión de imágenes)
  const imagesVersion = useUIStore(state => state.config.imagesVersion);

  // 2. CONSTRUCCIÓN DE URL (Evitamos strings vacíos innecesarios)
  const imageUrl = useMemo(() => {
    if (!content.image_url) return '';
    const separator = content.image_url.includes('?') ? '&' : '?';
    return `${content.image_url}${separator}v=${imagesVersion || '1'}`;
  }, [content.image_url, imagesVersion]);

  // 3. LÓGICA DE NAVEGACIÓN
  const isClickable = Boolean(content.link);

  const handleNavigation = () => {
    if (!content.link) return;
    
    // Si ya es una URL completa no tocamos nada, si no, aseguramos el slash
    const targetUrl = content.link.startsWith('http')
      ? content.link
      : content.link.startsWith('/') ? content.link : `/${content.link}`;

    window.open(targetUrl, '_blank', 'noopener,noreferrer');
  };

  return {
    imageUrl,
    isClickable,
    handleNavigation,
    hasTextOverlay: Boolean(content.title)
  };
};